module.exports = __webpack_public_path__ + "img/awardsAll_logo.093a75a1.svg";